import React, { Component } from "react";
import "./UserLinks.css";

// class UserLinks extends Component {
//   getLinkElements() {
//     const { userLinks } = this.props.config;
//     const { labeled } = this.props;
//     return userLinks.map(link => (
//       <button key={link.label} href={link.url}>
//         {labeled ? link.label : ""}
//       </button>
//     ));
//   }
//   render() {
//     const { userLinks } = this.props.config;
//     if (!userLinks) {
//       return null;
//     }
//     return <div className="user-links">{this.getLinkElements()}</div>;
//   }
// }

class UserLinks extends Component {
  getLinkElements = (userLinks) => {
    return userLinks.map(link => (
      <li key={link.label}
        className="list-inline-item g-mx-10"
        data-toggle="tooltip"
        data-placement="top"
        title={link.label}
      >
        <a
          href={link.url}
          className="g-color-white-opacity-0_5 g-color-white--hover"
        >
          <i className={link.iconClassName} />
        </a>
      </li>
    ))
  }

  render() {
    const { userLinks } = this.props.config;
    if (!userLinks) {
      return null;
    }
    return (
      <div className="col-md-4 align-self-center">
        <ul className="list-inline text-center text-md-right mb-0">
          {this.getLinkElements(userLinks)}
        </ul>
      </div>
    )
  }
}

export default UserLinks;



// WEBPACK FOOTER //
// ./src/components/UserLinks/UserLinks.jsx